<template>
    <div class="index_content">
        <div class="f-row">
          <Breadcrumb separator=">" class="breadcrumb_zdy">
              当前位置:
              <BreadcrumbItem :to="{name: 'NewsList'}">快讯Live</BreadcrumbItem>
              <BreadcrumbItem>快讯详情</BreadcrumbItem>
          </Breadcrumb>
          <div>
              <!-- <a href="javascript:history.go(-1)" ><i class="iconfont-sm">&#xe661;</i> 返回上一级页面</a> -->
          </div>
        </div>
        <div class="detail_bg">
            <div class="news_detail">
                <div class="detail">
                    <p class="title">{{newsDetail.title}}</p>
                    <p class="tip">
                        <span class="spa1">{{newsDetail.create_time | time_standard}}</span>
                        <span class="spa2" v-if="newsDetail.src_name"><em>{{newsDetail.src_name}}</em> 等{{newsDetail.content_count}}家媒体报道</span>
                        <span class="type_tag span_tag" v-for="item in newsDetail.type_arr" :key="item">{{item | dealName(meta.news_topic_type)}}</span>
                    </p>
                    <div class="iconfont-group">
                      <i class="iconfont s active" title="取消收藏" v-if="newsDetail.is_collect" @click="cancelCollect('0', newsDetail.id, delCollectCb)">&#xe66f;</i>
                      <i class="iconfont s" title="收藏" v-if="!newsDetail.is_collect"  @click="addCollect('0', newsDetail.id, addCollectCb)">&#xe66f;</i>
                      <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="haddleShare" @on-popper-hide="haddleShareHide">
                          <i class="iconfont w">&#xe641;</i>
                          <div slot="content" class="share_cnt clear">
                            <div class="share_img"></div>
                            <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                          </div>
                      </Poptip>
                    </div>

                    <p class="sumary">{{newsDetail.content_unsigned}}</p>

                    <div class="news-imgs" v-if="newsDetail.file_arr && newsDetail.file_arr.length > 0">
                        <img v-for="(item, index) in newsDetail.file_arr" :key="index" :src="$store.state.img_req_url + item.path">
                    </div>

                    <div class="about" v-if="comp.length != 0 || org.length != 0">
                        <div class="about_li" v-if="comp.length > 0">
                            <p class="title">关联公司</p>
                            <div class="about_tag">
                                <i class="iconfont">&#xe660;</i>
                                <span v-for="(item, index) in comp" :key="index" @click="goEntityDetail(item.uid,item.type)" onclick="_czc.push(['_trackEvent', '快讯详情页', '关联公司点击'])">{{item.short_name}}</span>
                            </div>
                        </div>
                        <div class="about_li" v-if="org.length > 0">
                            <p class="title">关联机构</p>
                            <div class="about_tag">
                                <i class="iconfont">&#xe660;</i>
                                <span v-for="(item, index) in org" :key="index" @click="goEntityDetail(item.uid,item.type)" onclick="_czc.push(['_trackEvent', '快讯详情页', '关联机构点击'])">{{item.short_name}}</span>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="news_tabs" v-if="news_arr.length != 0 || comp.length != 0 || org.length != 0">
                    <Menu mode="horizontal" theme="light" :active-name="select" @on-select="haddleSelect">
                        <MenuItem name="news" onclick="_czc.push(['_trackEvent', '快讯详情页', '快讯详情页tab点击（相关报道）'])">
                            <i class="iconfont">&#xe632;</i>相关报道
                        </MenuItem>
                        <MenuItem name="comp" v-if="comp.length != 0" onclick="_czc.push(['_trackEvent', '快讯详情页', '快讯详情页tab点击（关联公司）'])">
                            <i class="iconfont">&#xe6b9;</i>关联公司
                        </MenuItem>
                        <MenuItem name="org" v-if="org.length != 0" onclick="_czc.push(['_trackEvent', '快讯详情页', '快讯详情页tab点击（关联机构）'])">
                            <i class="iconfont">&#xe6ba;</i>关联机构
                        </MenuItem>
                    </Menu>
                    <div class="about_tab">
                        <AboutNews v-if="select == 'news'" :newsList="news_arr"></AboutNews>
                        <AboutCompany v-if="select == 'comp'" :entityList="comp" :meta="meta"></AboutCompany>
                        <AboutOrg v-if="select == 'org'" :org="org" :meta="meta"></AboutOrg>
                    </div>
                </div>

            </div>
            <div class="news_sibling">
                <div v-if="siblings.prev">
                    <p class="p1"><span @click="goTopicDetail(siblings.prev.uid)">上一篇</span></p>
                    <p class="p2" @click="goTopicDetail(siblings.prev.uid)">{{siblings.prev.title}}</p>
                </div>
                <div v-if="siblings.next">
                    <p class="p1"><span @click="goTopicDetail(siblings.next.uid)">下一篇</span></p>
                    <p class="p2" @click="goTopicDetail(siblings.next.uid)">{{siblings.next.title}}</p>
                </div>
            </div>

            <Spin fix v-if="detailLoading">
                <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
        </div>
    </div>
</template>

<script>
import { topicDetail, topicSibling } from '@/service'
import { collect_mixin } from 'js/collect_mixin'
import { get_meta } from 'js/get_meta'
import AboutNews from './components/AboutNews.vue'
import AboutCompany from './components/AboutCompany.vue'
import AboutOrg from './components/AboutOrg.vue'
export default {
  metaInfo() {
    return {
      title: this.meta_title
    }
  },
  mixins: [collect_mixin, get_meta],
  inject: ['reload','login'],
  data() {
    return {
      newsDetail: [],
      detailLoading: true,
      comp: [],
      org: [],
      news_arr: [],
      select: 'news',
      uid: this.$route.params.uid,
      siblings: {
        next: '',
        prev: ''
      },
      meta_title: '动脉橙-数字健康产业信息服务商'
    }
  },
  components: {
    AboutNews,
    AboutCompany,
    AboutOrg
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    }
  },
  methods: {
    async getDetail() {
      let res = await topicDetail({news_uid: this.$route.params.uid, user_key: this.user_key}, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.newsDetail = ''
        this.$set(this.$data, 'newsDetail', res.res[0])
        this.meta_title = this.newsDetail.title + '-动脉橙'
        this.comp = []
        this.org = []
        this.news_arr = []
        if(res.res[0].content_entity){
          res.res[0].content_entity.map((a) => {
            if(a.type == 0) {
              this.comp.push(a)
            }else if(a.type == 1){
              this.org.push(a)
            }
          })
        }
        if(res.res[0].news_arr){
          res.res[0].news_arr.map((a) => {
            if(this.news_arr.length > 0){
              let index = this.news_arr.findIndex((b) => a.title === b.title && a.src_name === b.src_name )
              if(index == -1) this.news_arr.push(a)
            }else{
              this.news_arr.push(a)
            }
          })
        }
        this.getTopicSibling(this.newsDetail.create_time)

      } else {
        if (res.code == '10404') {
          console.log('?')
          this.$router.replace({name: 'NoFound'})
        } else {
          this.$Message.error(res.message)
        }
      }
    },
    goEntityDetail(uid,type) {
      if (this.user_key) {
        if(type == 1){
          const { href } = this.$router.resolve({ name: "OrgDetail", params: { uid: uid } })
          window.open(href, '_blank')
        } else if(type == 0){
          const { href } = this.$router.resolve({ name: "CompanyDetail", params: { uid: uid } })
          window.open(href, '_blank')
        } else if(type == 3){
          const { href } = this.$router.resolve({ name: "HospitalDetail", params: { uid: uid } })
          window.open(href, '_blank')
        }
      } else {
        this.login()
      }
    },
    goTopicDetail(uid) {
      // console.log(uid)
      this.$router.replace({ name: 'NewsDetail', params: {uid: uid} })
      this.reload()
    },
    async getTopicSibling(t) {
      let res = await topicSibling({time: t}, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.siblings.next = res.next[0]
        this.siblings.prev = res.preg[0]
        this.detailLoading = false
        // console.log(this.siblings)
      } else {
        this.$Message.error(res.message)
      }
    },
    haddleSelect(val) {
      this.select = val
    },
    addCollectCb() {
      this.newsDetail.is_collect = 1
    },
    delCollectCb() {
      this.newsDetail.is_collect = 0
    },
    haddleShare() {
      let share_link = this.$store.state.index2_path+ '/News/newsDetail?uid=' + this.newsDetail.uid
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    haddleShareHide() {
      $('.share_img').html('')
    },
  },
  created() {
    let arr = ['news_topic_type','dynview_tag','dynview_tag_type','employee','round','unit']
    this.getMeta(arr, this.getDetail)
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.index_content
  padding: 16px 0 20px
  .detail_bg
    display: flex
    position: relative
    margin-top: 10px
    .news_detail
      flex: auto
      position: relative
      .detail
        padding: 25px 50px 30px
        position: relative
        commonBgColor(#1f2330, #FFFFFF)
        min-height: 190px
        .title
          font-size: 28px
          commonColor(#FFFFFF, #333333)
          line-height: 44px
          font-weight: bold
        .tip
          font-size: 14px
          commonColor(rgba(255,255,255,.4), #999999)
          margin-top: 10px
          line-height: 24px
          .spa2
            margin-left: 21px
            position: relative
            &:before
              content: ''
              position: absolute
              width: 1px
              height: 13px
              commonBgColor(rgba(255,255,255,.4), #999999)
              top: 2px
              left: -11px
          .type_tag
            commonBgColor(#283545, #F5F5F5)
            commonColor(#939aa2, #666666)
            padding: 6px 10px
            margin-right: 10px
            margin-left: 20px
            &+.type_tag
              margin-left: 0
        .iconfont-group
          float: right;
          margin-top: -21px;
        .iconfont-group,>>>.ivu-poptip
          i
            width: 18px;
            height: 18px;
            text-align: center;
            line-height: 18px;
            commonColor(#ADAFB4, #cccccc)
            commonBgColor(#343844,#f3f3f3)
            border-radius:2px;
            font-size: 10px;
            display: inline-block;
            cursor: pointer;
            &.s
              margin-right: 6px;
            &.s:hover,&.s.active
              color: #fff;
              background:rgba(250, 122, 80, 1);
            &.w:hover,&.w.active
              color: #fff;
              background:#63BF61;
          .ivu-poptip-inner
            border-radius: 0
            .share_cnt
              padding: 10px 20px 10px 10px
              .share_img
                width: 80px
                height: 80px
                float: left
                background: #f0f0f0
              p
                line-height: 20px
                color: #666
                float: right
                margin-top: 20px
                font-size: 14px
          .ivu-poptip-popper
            transform: translate(13px, 0)
        .sumary
          margin-top: 30px
          font-size: 16px
          commonColor(rgba(255,255,255,.9), #333333)
          line-height: 26px
        .news-imgs
          margin-top: 20px
          font-size: 0
          img
            max-width: 100% !important
            display: block
            margin: 0 auto
            &+img
              margin-top: 20px
        .about
          .about_li
            display: flex
            margin-top: 15px
          .title
            line-height: 1
            font-size: 14px
            color: #797B83
            font-weight: normal
            flex: 0 0 56px
          .about_tag
            flex: auto
            padding-left: 15px
            font-size: 0
            i
              margin-right: 10px
              line-height: 14px
              font-size: 12px
              color: rgba(250, 122, 80, 1)
            span
              line-height: 14px
              font-size: 12px
              color: rgba(250, 122, 80, 1)
              margin-right: 21px
              cursor: pointer
              position: relative
              &:hover
                color: #FC9C7C
            span+span:before
              content: ''
              cursor: none
              position: absolute
              width: 1px
              height: 12px
              background: #40444f
              top: 1px
              left: -11px

          .tip
            font-size: 14px
            line-height: 40px
            color: rgba(255,255,255,.5)
            text-align: center
      .news_tabs
        .ivu-menu-light
          commonBgColor(#2A2F42, #F9F9F9)
          height: 40px
          line-height: 40px
          z-index: 2
          &:after
            content: none
          .ivu-menu-item
            font-size: 14px
            padding: 0
            margin-left: 30px
            commonColor(#8f9198, #999999)
            .iconfont
              font-size: 14px
            &:hover
              border-color: transparent
              color: rgba(250, 122, 80, 1) !important
            &:first-of-type
              margin-left: 50px
          .ivu-menu-item-active
            border-color: rgba(250, 122, 80, 1) !important
            color: rgba(250, 122, 80, 1) !important
            font-weight: bold
    .news_sibling
      flex: 0 0 260px
      margin-left: 16px
      // margin-top: 10px
      > div
        commonBgColor(#1f2330, #FFFFFF)
        padding: 24px 20px
        &+div
          padding-top: 0
        .p1
          commonColor(#8F9198, #999999)
          font-size: 14px
          padding-left: 14px
          position: relative
          &:before
            content: ''
            position: absolute
            width: 4px
            height: 14px
            background: linear-gradient(180deg,#FFB75E 0%,#F46B45 100%)
            border-radius: 2px
            top: 0
            left: 0
          span
            cursor: pointer
            &:hover
              color: rgba(250, 122, 80, 1)
        .p2
          font-size: 14px
          commonColor(#E9E9EB, #333333)
          line-height: 22px
          margin: 8px 0 -3px 0
          &:hover
            cursor: pointer
            color: rgba(250, 122, 80, 1)
</style>
